import _values from 'lodash/values';

const sharingNetworks = {
  DEFAULT:   'campaign:share:default',
  FACEBOOK:  'campaign:share:facebook',
  TWITTER:   'campaign:share:twitter',
  PINTEREST: 'campaign:share:pinterest',
  WHATSAPP:  'campaign:share:whatsapp',
};

sharingNetworks.ALL = _values(sharingNetworks);

export default sharingNetworks;
